import HomeTemplate from 'templates/Home';

const Home: React.FC = () => {
  return <HomeTemplate />;
};

export default Home;
